import { SystemParameter, SystemParameterFromJSON } from '@/api'
import * as runtime from '../runtime'

export interface GetSystemParameterRequest {
  codeKey: string
  codeKeys: string[]
  code: string
}

export interface UpdateSystemParametersRequest {
  parameterKey: string
  parameterKeyRevision: number
  codes: {
    code: string
    name: string
    shortName: string
    option1: string
    option2: string
    option3: string
    option4: string
    option5: string
    option6: string
  }[]
}

/**
 * no description
 */
export class SystemParameterApi extends runtime.BaseAPI {
  /**
   * システムパラメーターの一覧を取得する。
   * システムパラメーター取得
   */
  async getSystemParameters(
    request: GetSystemParameterRequest
  ): Promise<SystemParameter[]> {
    const queryParameters: runtime.HTTPQuery = {}

    if (request.codeKey !== '') {
      queryParameters.code_key = request.codeKey
    }

    if (request.codeKeys.length !== 0) {
      queryParameters.code_keys = request.codeKeys
    }

    if (request.code !== '') {
      queryParameters.code = request.code
    }

    const response = await this.requestGet(
      `/system-parameters`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemParameterFromJSON)
    ).value()
  }

  /**
   * システムパラメータを更新する
   * システムパラメータ更新
   */
  async updateSystemParameters(
    request: UpdateSystemParametersRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = {
      parameter_key: request.parameterKey,
      parameter_key_revision: request.parameterKeyRevision,
      codes: []
    }

    request.codes.forEach((code, index) => {
      bodyParameters.codes[index] = {
        code: code.code,
        name: code.name,
        short_name: code.shortName,
        option1: code.option1,
        option2: code.option2,
        option3: code.option3,
        option4: code.option4,
        option5: code.option5,
        option6: code.option6
      }
    })

    const response = await this.requestPut('/system-parameters', bodyParameters)
    return new runtime.VoidApiResponse(response)
  }
}
